import React from 'react';
import Layout from '../../components/layout';

import './styles.scss';
import UIError from './uiError';
import UnauthorizedError from './unauthorized';

const Errors = ({ location: { state: locationState = {} } = {}, history }) => {
  const { ui = false } = locationState;
  return (
    <Layout>
      {ui ? (
        <UIError history={history} />
      ) : (
        <UnauthorizedError history={history} />
      )}
    </Layout>
  );
};

export default Errors;
